window.OrcamentosEmAbertoClienteController = ObjectBase.extend({
    show: function() {

        if (!this.modal || !this.model) {
            return;
        }

        this.$modal = $(this.modal);

        if (!this.$modal || this.$modal.length === 0) {
            return;
        }


        this.filtros = $.extend({}, this.model.Filtros);
        var pageMessage = $.extend({}, this.model.Pedidos);

        this.model = ko.mapping.fromJS({
            Pedidos: this.model.Pedidos.Entities,
            ExigirSenha: this.model.ExigirSenha,
            Senha: null,
            DataInicial: null,
            DataFinal: null
        });

        this.controller.applyBindings(this, this.$modal[0]);

        this.atualizarPaginador(pageMessage);

        this.$modal.on("hidden.bs.modal", $.proxy(this.fechar, this));
        this.$modal.modal();

    },

    fechar: function() {
        this.model.Pedidos(undefined);
        this.model.Senha(undefined);
        this.model.DataInicial(undefined);
        this.model.DataFinal(undefined);
    },

    atualizarPaginador: function(data) {

        this.paginador = new Paginator({
            container: "#page-modalOrcamentoEmAberto",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

    },

    paginar: function(e) {
        this.pesquisar(e.page);
    },

    pesquisar: function(pagina) {

        var self = this;

        this.filtros.NumeroPagina = pagina;

        if (this.model.DataInicial()) {
            this.filtros.DataInicial = this.model.DataInicial();
        }

        if (this.model.DataFinal()) {
            this.filtros.DataFinal = this.model.DataFinal();
        }

        global.ajax({
            url: "/Orcamento/ListarPedidosEmAberto",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({ filtros: this.filtros }),
            success: function(data) {

                if (!data) {
                    return;
                }

                var m = ko.mapping.fromJS(data.Entities);

                self.model.Pedidos(m());
                self.atualizarPaginador(data);

            }
        });

    },

    filtrar: function() {

        if (!global.isFormValid("#form-filtrar-modalOrcamentoEmAberto")) {
            return;
        }

        this.pesquisar(1);

    },

    definirCliente: function(model, element) {

        if (!global.isFormValid("#form-senha-modalOrcamentoEmAberto")) {
            return;
        }

        var self = this;

        global.ajax({
            blockUI: false,
            url: "/Orcamento/AtualizarCliente",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                codigoCliente: this.cliente.get("Codigo"),
                senha: this.model.Senha()
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                if (!data.HasErrors) {
                    self.$modal.modal("hide");
                    self.clienteDefinidoCallback(self.cliente, data);
                }

            }
        });

    }


});